export default __webpack_public_path__ + "static/media/icon-more-circle-outline.193ca4fd.svg";